import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import type { ChartOptions } from "chart.js";
import { Line } from "react-chartjs-2";
import type { PkMonthlyPoint } from "../../../types/playerPk";
import { formatEtMonth } from "../../../utils/etDate";
import "./pk.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const TICK_COLOR = "rgb(199, 238, 255)";
const GRID_COLOR = "rgb(70, 130, 180)";

const options: ChartOptions<"line"> = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: { mode: "index", intersect: false },
  scales: {
    x: {
      ticks: { color: TICK_COLOR, maxTicksLimit: 8, maxRotation: 0 },
      grid: { color: GRID_COLOR }
    },
    y: {
      beginAtZero: true,
      ticks: { color: TICK_COLOR, precision: 0 },
      grid: { color: GRID_COLOR }
    }
  },
  plugins: {
    legend: { position: "top", labels: { color: TICK_COLOR } }
  }
};

type Props = {
  monthly: PkMonthlyPoint[];
};

const MonthlyChart = ({ monthly }: Props) => {
  const manyMonths = monthly.length > 24;
  const point = manyMonths ? 0 : 3;
  return (
    <div className="pk-card">
      <div className="pk-chart-box">
        <Line
          options={options}
          data={{
            labels: monthly.map((m) => formatEtMonth(m.month)),
            datasets: [
              {
                label: "Kills",
                data: monthly.map((m) => m.kills),
                borderColor: "rgb(70, 130, 180)",
                backgroundColor: "rgb(70, 130, 180)",
                pointRadius: point,
                tension: 0.2
              },
              {
                label: "Deaths",
                data: monthly.map((m) => m.deaths),
                borderColor: "rgb(255, 99, 132)",
                backgroundColor: "rgb(255, 99, 132)",
                pointRadius: point,
                tension: 0.2
              },
              {
                label: "Assists",
                data: monthly.map((m) => m.assists),
                borderColor: "rgba(174, 217, 224, 0.4)",
                backgroundColor: "rgba(174, 217, 224, 0.4)",
                borderWidth: 1.5,
                pointRadius: manyMonths ? 0 : 2,
                tension: 0.2
              }
            ]
          }}
        />
      </div>
    </div>
  );
};

export default MonthlyChart;
